<template>
  <div class="myAddress">
    <div class="add">
      <el-button type="primary" plain @click="editOnline()">
        新增收货地址
      </el-button>
      <div v-if="addressList.length > 0">
        您已创建<span> {{ addressList.length }} </span>个收货地址
      </div>
    </div>
    <div class="item" v-for="(item, index) in addressList" :key="index">
      <div><span>工号：</span>{{ item['3ulvzh2pgygl0vga'] }}</div>
      <div><span>联系人：</span>{{ item.mdbcej4opshigmrs }}</div>
      <div><span>联系方式：</span>{{ item.xejhteu0ub3fd3eh }}</div>
      <div>
        <span>收货地址：</span>
        {{
          item.b3ccmzbfyzlwy9sc && item.b3ccmzbfyzlwy9sc.length > 0
            ? item.b3ccmzbfyzlwy9sc.map((el) => el.value).join('-')
            : ''
        }}{{ item['9simp0sjii9s0m33'] }}
      </div>
      <img
        src="../../assets/img/edit.svg"
        alt=""
        class="edit"
        @click="editOnline(item)"
      />
      <img
        src="../../assets/img/close.png"
        alt=""
        class="del"
        @click="delOnline(item.id)"
      />
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="478px"
      :show-close="false"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="工号" required>
          <el-input
            v-model="form['3ulvzh2pgygl0vga']"
            placeholder="请输入工号"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人" required>
          <el-input
            v-model="form.mdbcej4opshigmrs"
            placeholder="请输入联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" required>
          <el-input
            v-model="form.xejhteu0ub3fd3eh"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="所在地区" required>
          <el-cascader
            v-model="form.b3ccmzbfyzlwy9sc"
            :options="city"
            :props="props"
            placeholder="请选择省市区"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" required>
          <el-input
            placeholder="请输入详细地址"
            v-model="form['9simp0sjii9s0m33']"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="updateOnline()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { online, delOnline, updateOnline, postOnline } from "@/api/platform";
import city from '@/util/city'
export default {
  data () {
    return {
      form_head_uuid: '0f5b2fde26c04882a5d6c5c885a30a3f',
      addressList: [],
      dialogVisible: false,
      form: {},
      city,
      props: {
        label: 'name',
        value: 'id'
      }
    }
  },
  components: {},
  created () { },
  computed: {},
  mounted () {
    this.online()
  },
  methods: {
    async online () {
      const { form_head_uuid } = this
      const { result } = await online({
         page: 1,
        limit: 100,
        keyword: '',
        select_option: '',
        form_head_uuid,
      })
      this.addressList = result
    },
    // 删除地址
    async delOnline (id) {
      const { form_head_uuid } = this
      this.$confirm('是否确认删除该地址?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await delOnline({
          form_head_uuid,
          ids: [id]
        })
        this.online()
      })
    },
    // 编辑详情
    editOnline (data) {
      this.dialogVisible = true
      if (data && data.id) {
        let form = JSON.parse(JSON.stringify(data))
        const { id, mdbcej4opshigmrs, b3ccmzbfyzlwy9sc, xejhteu0ub3fd3eh } = form
        this.form = {
          '3ulvzh2pgygl0vga': form['3ulvzh2pgygl0vga'],
          id,
          mdbcej4opshigmrs,
          xejhteu0ub3fd3eh,
          '9simp0sjii9s0m33': form['9simp0sjii9s0m33'],
          b3ccmzbfyzlwy9sc: b3ccmzbfyzlwy9sc.map(el => el.id)
        }
      } else {
        this.form = {}
      }

    },

    async updateOnline () {
      const { form_head_uuid, form } = this
      const validations = [
        { field: '3ulvzh2pgygl0vga', error: '请输入工号' },
        { field: 'mdbcej4opshigmrs', error: '请输入联系人' },
        { field: 'xejhteu0ub3fd3eh', error: '请输入联系电话' },
        { field: 'b3ccmzbfyzlwy9sc', error: '请输入所在地区' },
        { field: '9simp0sjii9s0m33', error: '请输入详细地址' },
      ];
      for (const { field, error } of validations) {
        if (!form[field]) {
          return this.$notify.error({ title: '提示', message: error });
        }
      }
      // const phonePattern = /^1[3-9]\d{9}$/;
      // if (!phonePattern.test(form.xejhteu0ub3fd3eh)) {
      //   return this.$notify.error({ title: '提示', message: '请输入正确的手机号码' });
      // }

      if (this.form.id) {
        await updateOnline({
          ...this.form,
          form_head_uuid
        })

      } else {
        await postOnline({
          ...this.form,
          form_head_uuid
        })
      }
      this.$notify({
        title: "提示",
        message: this.form.id ? '修改成功' : '新增成功',
        type: "success",
      });
      this.dialogVisible = false
      this.form = {}
      this.online()
    }
  },
}
</script>
<style lang='less' scoped>
@import '../../assets/css/var.less';
.myAddress {
  width: 100%;
  .add {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    .el-button {
      padding: 9px 10px;
      margin-right: 10px;
    }
    div {
      font-size: 12px;
      color: #666;
      span {
        color: @thirdColor;
        font-weight: 500;
      }
    }
  }
  .item {
    padding: 20px;
    border: 1px solid #dbdbdb;
    margin-bottom: 20px;
    font-size: 12px;
    color: #666;
    position: relative;
    div {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      line-height: 28px;
      span {
        color: #999;
        width: 60px;
        text-align: right;
      }
    }
    .edit {
      width: 20px;
      position: absolute;
      right: 20px;
      bottom: 20px;
      cursor: pointer;
    }
    .del {
      position: absolute;
      right: 20px;
      top: 20px;
      width: 15px;
      cursor: pointer;
    }
  }
}
.el-cascader {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/client/MyAddress.vue